import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Suspense, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter as Router, Routes, Route, } from 'react-router-dom';
import Loading from 'components/library/Loading';
import ServerError from 'views/ServerError';
import * as statuses from 'services/store/states';
import { fetchProject } from 'services/store/features/project/actions';
import { useTranslation } from 'react-i18next';
import { logError } from 'utils/logs';
import LandingPage from 'views/LandingPage';
var AppRouter = function () {
    var dispatch = useDispatch();
    var project = useSelector(function (state) { return state.project; });
    var t = useTranslation().t;
    var attempt = 0;
    var pathParts = window.location.pathname.split('/').filter(Boolean);
    var id = parseInt(pathParts.find(function (part) { return !isNaN(parseInt(part, 10)); }) || "0");
    useEffect(function () {
        if (project.fetching_status === statuses.FAIL) {
            logError(new Error('Failed to fetch project'));
        }
        if (id && [statuses.IDLE, statuses.FAIL].includes(project.fetching_status) && attempt < 5) {
            attempt++;
            dispatch(fetchProject(id, t));
        }
    }, [project.fetching_status, dispatch, t]);
    if (id === 0 || (project.fetching_status === statuses.FAIL && attempt >= 5)) {
        return _jsx(ServerError, {});
    }
    else if (project.fetching_status === statuses.SUCCESS) {
        return (_jsx(Router, { children: _jsx(Suspense, { fallback: _jsx(Loading, {}), children: _jsxs(Routes, { children: [_jsx(Route, { path: "/project/:id", element: _jsx(LandingPage, {}) }), _jsx(Route, { path: "/:id", element: _jsx(LandingPage, {}) })] }) }) }));
    }
};
export default AppRouter;
